// extracted by mini-css-extract-plugin
module.exports =  {"verticalCompensation":"2px","unit":"var(--ring-unit)","downloadLink":"ArtifactsDownloadAll-module__downloadLink--MG"};